<script setup></script>

<template>
  <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.7992 1.68945H3.13249C2.21201 1.68945 1.46582 2.516 1.46582 3.53561V23.8433C1.46582 24.8629 2.21201 25.6895 3.13249 25.6895H24.7992C25.7196 25.6895 26.4658 24.8629 26.4658 23.8433V3.53561C26.4658 2.516 25.7196 1.68945 24.7992 1.68945Z"
      stroke="currentColor"
      stroke-width="2.52632"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 8L19 13.5L11 19V8Z"
      stroke="currentColor"
      stroke-width="2.52632"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
